var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-password-setting',{staticClass:"pt-password-setting__page"})
}
var staticRenderFns = []

export { render, staticRenderFns }